import { Component, Input } from '@angular/core';
import { AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfigWindowComponent } from './config-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';


@Component({
  selector: 'config-range-date',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="430" title="{{ label }}" *ngIf="opened" (close)="onClose()">
    
    <kendo-daterange>
      <div class="example-wrapper form-detail">        
        <div class="row m0">
          <div class="col-xs-6 col-sm-6 example-col">
              <kendo-label text="Inicio:"></kendo-label>
              <kendo-textbox-container>
                <kendo-dateinput kendoDateRangeStartInput [(value)]="range.start" [format]="'dd-MMM-yyyy'"></kendo-dateinput>
              </kendo-textbox-container>              
          </div>
          <div class="col-xs-6 col-sm-6 example-col">
              <kendo-label text="Fin:"></kendo-label>
              <kendo-textbox-container>
                <kendo-dateinput kendoDateRangeEndInput [(value)]="range.end" [format]="'dd-MMM-yyyy'"></kendo-dateinput>
              </kendo-textbox-container>              
          </div>
        </div>
      </div>
      <!--<kendo-daterange-popup>
        <ng-template kendoDateRangePopupTemplate>
          <kendo-multiviewcalendar kendoDateRangeSelection [views]="'2'"></kendo-multiviewcalendar>
        </ng-template>        
      </kendo-daterange-popup>-->
    </kendo-daterange>
    
    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSuccesfull()">Seleccionar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `]
})
export class ConfigRangeDateComponent extends ConfigWindowComponent {

  //Variables

  // public date: Date;

  @Input() label: string = 'Seleccionar rango de fechas';

  public range = { start: null, end: null };
  
  //Métodos

  constructor(protected authService: AuthService, protected intl: IntlService) {

    super(authService);

  }
  
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    this.range = { start: new Date(), end: new Date() };

    return new FormGroup({
      'report': new FormControl((dataItem) ? dataItem.report: '')
    });

  };

  public onSuccesfull(): void {
    
    console.log('onSuccesfull', this.form.value.date)

    this.config.emit({
      dataItem: {
        report: this.form.value.report,
        range: {
          start: this.intl.formatDate(this.range.start, "yyyy-MM-dd"),
          end: this.intl.formatDate(this.range.end, "yyyy-MM-dd")
        }
      }
    });
    this.opened = false;

  }

}
